import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Box,
  Divider
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SellIcon from '@mui/icons-material/Sell';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import CloseIcon from '@mui/icons-material/Close';

const MobileOptionDrawer = ({ 
  open, 
  onClose, 
  instrument, 
  onBuyClick, 
  onSellClick,
  onChartClick 
}) => {
  if (!instrument) return null;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          bgcolor: 'background.paper',
          overflow: 'visible',
          pb: 2
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)'
        }
      }}
      disableScrollLock
      onClick={(e) => e.stopPropagation()}
    >
      <Box 
        sx={{ 
          width: 40, 
          height: 4, 
          backgroundColor: 'grey.300', 
          borderRadius: 2,
          position: 'absolute',
          top: -12,
          left: '50%',
          transform: 'translateX(-50%)'
        }} 
      />

      <Box sx={{ 
        p: 2, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {instrument.display_name || instrument.trading_symbol}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {instrument.exchange} • ₹{parseFloat(instrument.ltp || 0).toFixed(2)}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" sx={{ color: 'text.secondary' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <List sx={{ p: 0 }}>
        <ListItem 
          button 
          onClick={() => { onBuyClick(); onClose(); }}
          sx={{ 
            py: 1.5,
            '&:hover': { backgroundColor: 'success.light' }
          }}
          disabled={!instrument.tradable}
        >
          <ListItemIcon sx={{ color: 'success.main', minWidth: 36 }}>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText 
            primary="Buy" 
            primaryTypographyProps={{ 
              fontWeight: 600, 
              color: 'success.main',
              fontSize: '0.9rem'
            }}
          />
        </ListItem>
        
        <ListItem 
          button 
          onClick={() => { onSellClick(); onClose(); }}
          sx={{ 
            py: 1.5,
            '&:hover': { backgroundColor: 'error.light' }
          }}
          disabled={!instrument.tradable}
        >
          <ListItemIcon sx={{ color: 'error.main', minWidth: 36 }}>
            <SellIcon />
          </ListItemIcon>
          <ListItemText 
            primary="Sell" 
            primaryTypographyProps={{ 
              fontWeight: 600, 
              color: 'error.main',
              fontSize: '0.9rem'
            }}
          />
        </ListItem>

        <ListItem 
          button 
          onClick={() => { onChartClick(); onClose(); }}
          sx={{ 
            py: 1.5,
            color: 'primary.main',
            '&:hover': { backgroundColor: 'primary.light' }
          }}
        >
          <ListItemIcon sx={{ color: 'primary.main', minWidth: 36 }}>
            <ShowChartIcon />
          </ListItemIcon>
          <ListItemText 
            primary="Charts" 
            primaryTypographyProps={{ fontSize: '0.9rem' }}
          />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default MobileOptionDrawer;
